// ISO 3166-1 alpha-2
// ⚠️ No support for IE 11
export function countryToFlag(isoCode) {
    return typeof String.fromCodePoint !== 'undefined'
        ? isoCode
            .toUpperCase()
            .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
        : isoCode;
}

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
// And merged with Currency Data from https://gist.githubusercontent.com/HarishChaudhari/4680482/raw/b61a5bdf5f3d5c69399f9d9e592c4896fd0dc53c/country-code-to-currency-code-mapping.csv

export const countries = [
    {
        "code": "AD",
        "label": "Andorra",
        "phone": "376",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "AE",
        "label": "United Arab Emirates",
        "phone": "971",
        "currency": "Dirham",
        "currencyCode": "AED"
    },
    {
        "code": "AF",
        "label": "Afghanistan",
        "phone": "93",
        "currency": "Afghani",
        "currencyCode": "AFN"
    },
    {
        "code": "AG",
        "label": "Antigua and Barbuda",
        "phone": "1-268",
        "currency": "East Caribbean Dollar",
        "currencyCode": "XCD"
    },
    {
        "code": "AI",
        "label": "Anguilla",
        "phone": "1-264",
        "currency": "East Caribbean Dollar",
        "currencyCode": "XCD"
    },
    {
        "code": "AL",
        "label": "Albania",
        "phone": "355",
        "currency": "Lek",
        "currencyCode": "ALL"
    },
    {
        "code": "AM",
        "label": "Armenia",
        "phone": "374",
        "currency": "Dram",
        "currencyCode": "AMD"
    },
    {
        "code": "AO",
        "label": "Angola",
        "phone": "244",
        "currency": "Angolan kwanza",
        "currencyCode": "AOA"
    },
    {
        "code": "AQ",
        "label": "Antarctica",
        "phone": "672",
        "currency": "Antarctican dollar",
        "currencyCode": "AQD"
    },
    {
        "code": "AR",
        "label": "Argentina",
        "phone": "54",
        "currency": "Peso",
        "currencyCode": "ARS"
    },
    {
        "code": "AS",
        "label": "American Samoa",
        "phone": "1-684",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "AT",
        "label": "Austria",
        "phone": "43",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "AU",
        "label": "Australia",
        "phone": "61",
        "currency": "Australian Dollars",
        "currencyCode": "AUD"
    },
    {
        "code": "AW",
        "label": "Aruba",
        "phone": "297",
        "currency": "Netherlands Antilles Guilder",
        "currencyCode": "ANG"
    },
    {
        "code": "AX",
        "label": "Alland Islands",
        "phone": "358",
        "currency": "Euro",
        "currencyCode": "EUR"
    },
    {
        "code": "AZ",
        "label": "Azerbaijan",
        "phone": "994",
        "currency": "Manat",
        "currencyCode": "AZN"
    },
    {
        "code": "BA",
        "label": "Bosnia and Herzegovina",
        "phone": "387",
        "currency": "Bosnia and Herzegovina convertible mark",
        "currencyCode": "BAM"
    },
    {
        "code": "BB",
        "label": "Barbados",
        "phone": "1-246",
        "currency": "Barbadian Dollar",
        "currencyCode": "BBD"
    },
    {
        "code": "BD",
        "label": "Bangladesh",
        "phone": "880",
        "currency": "Taka",
        "currencyCode": "BDT"
    },
    {
        "code": "BE",
        "label": "Belgium",
        "phone": "32",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "BF",
        "label": "Burkina Faso",
        "phone": "226",
        "currency": "CFA Franc BCEAO",
        "currencyCode": "XOF"
    },
    {
        "code": "BG",
        "label": "Bulgaria",
        "phone": "359",
        "currency": "Lev",
        "currencyCode": "BGN"
    },
    {
        "code": "BH",
        "label": "Bahrain",
        "phone": "973",
        "currency": "Bahraini Dinar",
        "currencyCode": "BHD"
    },
    {
        "code": "BI",
        "label": "Burundi",
        "phone": "257",
        "currency": "Burundi Franc",
        "currencyCode": "BIF"
    },
    {
        "code": "BJ",
        "label": "Benin",
        "phone": "229",
        "currency": "CFA Franc BCEAO",
        "currencyCode": "XOF"
    },
    {
        "code": "BL",
        "label": "Saint Barthelemy",
        "phone": "590",
        "currency": "Euro",
        "currencyCode": "EUR"
    },
    {
        "code": "BM",
        "label": "Bermuda",
        "phone": "1-441",
        "currency": "Bermudian Dollar",
        "currencyCode": "BMD"
    },
    {
        "code": "BN",
        "label": "Brunei Darussalam",
        "phone": "673",
        "currency": "Bruneian Dollar",
        "currencyCode": "BND"
    },
    {
        "code": "BO",
        "label": "Bolivia",
        "phone": "591",
        "currency": "Boliviano",
        "currencyCode": "BOB"
    },
    {
        "code": "BR",
        "label": "Brazil",
        "phone": "55",
        "currency": "Brazil",
        "currencyCode": "BRL"
    },
    {
        "code": "BS",
        "label": "Bahamas",
        "phone": "1-242",
        "currency": "Bahamian Dollar",
        "currencyCode": "BSD"
    },
    {
        "code": "BT",
        "label": "Bhutan",
        "phone": "975",
        "currency": "Indian Rupee",
        "currencyCode": "INR"
    },
    {
        "code": "BV",
        "label": "Bouvet Island",
        "phone": "47",
        "currency": "Norwegian Krone",
        "currencyCode": "NOK"
    },
    {
        "code": "BW",
        "label": "Botswana",
        "phone": "267",
        "currency": "Pula",
        "currencyCode": "BWP"
    },
    {
        "code": "BY",
        "label": "Belarus",
        "phone": "375",
        "currency": "Belarus Ruble",
        "currencyCode": "BYR"
    },
    {
        "code": "BZ",
        "label": "Belize",
        "phone": "501",
        "currency": "Belizean Dollar",
        "currencyCode": "BZD"
    },
    {
        "code": "CA",
        "label": "Canada",
        "phone": "1",
        "currency": "Canadian Dollar",
        "currencyCode": "CAD"
    },
    {
        "code": "CC",
        "label": "Cocos (Keeling) Islands",
        "phone": "61",
        "currency": "Australian Dollars",
        "currencyCode": "AUD"
    },
    {
        "code": "CD",
        "label": "Congo, Democratic Republic of the",
        "phone": "243",
        "currency": "Congolese Frank",
        "currencyCode": "CDF"
    },
    {
        "code": "CF",
        "label": "Central African Republic",
        "phone": "236",
        "currency": "CFA Franc BEAC",
        "currencyCode": "XAF"
    },
    {
        "code": "CG",
        "label": "Congo, Republic of the",
        "phone": "242",
        "currency": "CFA Franc BEAC",
        "currencyCode": "XAF"
    },
    {
        "code": "CH",
        "label": "Switzerland",
        "phone": "41",
        "currency": "Swiss Franc",
        "currencyCode": "CHF"
    },
    {
        "code": "CI",
        "label": "Cote d'Ivoire",
        "phone": "225",
        "currency": "CFA Franc BCEAO",
        "currencyCode": "XOF"
    },
    {
        "code": "CK",
        "label": "Cook Islands",
        "phone": "682",
        "currency": "New Zealand Dollars",
        "currencyCode": "NZD"
    },
    {
        "code": "CL",
        "label": "Chile",
        "phone": "56",
        "currency": "Chilean Peso",
        "currencyCode": "CLP"
    },
    {
        "code": "CM",
        "label": "Cameroon",
        "phone": "237",
        "currency": "CFA Franc BEAC",
        "currencyCode": "XAF"
    },
    {
        "code": "CN",
        "label": "China",
        "phone": "86",
        "currency": "Yuan Renminbi",
        "currencyCode": "CNY"
    },
    {
        "code": "CO",
        "label": "Colombia",
        "phone": "57",
        "currency": "Peso",
        "currencyCode": "COP"
    },
    {
        "code": "CR",
        "label": "Costa Rica",
        "phone": "506",
        "currency": "Costa Rican Colon",
        "currencyCode": "CRC"
    },
    {
        "code": "CU",
        "label": "Cuba",
        "phone": "53",
        "currency": "Cuban Peso",
        "currencyCode": "CUP"
    },
    {
        "code": "CV",
        "label": "Cape Verde",
        "phone": "238",
        "currency": "Escudo",
        "currencyCode": "CVE"
    },
    {
        "code": "CX",
        "label": "Christmas Island",
        "phone": "61",
        "currency": "Australian Dollars",
        "currencyCode": "AUD"
    },
    {
        "code": "CY",
        "label": "Cyprus",
        "phone": "357",
        "currency": "Cypriot Pound",
        "currencyCode": "CYP"
    },
    {
        "code": "CZ",
        "label": "Czech Republic",
        "phone": "420",
        "currency": "Koruna",
        "currencyCode": "CZK"
    },
    {
        "code": "DE",
        "label": "Germany",
        "phone": "49",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "DJ",
        "label": "Djibouti",
        "phone": "253",
        "currency": "Djiboutian Franc",
        "currencyCode": "DJF"
    },
    {
        "code": "DK",
        "label": "Denmark",
        "phone": "45",
        "currency": "Danish Krone",
        "currencyCode": "DKK"
    },
    {
        "code": "DM",
        "label": "Dominica",
        "phone": "1-767",
        "currency": "East Caribbean Dollar",
        "currencyCode": "XCD"
    },
    {
        "code": "DO",
        "label": "Dominican Republic",
        "phone": "1-809",
        "currency": "Dominican Peso",
        "currencyCode": "DOP"
    },
    {
        "code": "DZ",
        "label": "Algeria",
        "phone": "213",
        "currency": "Algerian Dinar",
        "currencyCode": "DZD"
    },
    {
        "code": "EC",
        "label": "Ecuador",
        "phone": "593",
        "currency": "Sucre",
        "currencyCode": "ECS"
    },
    {
        "code": "EE",
        "label": "Estonia",
        "phone": "372",
        "currency": "Estonian Kroon",
        "currencyCode": "EEK"
    },
    {
        "code": "EG",
        "label": "Egypt",
        "phone": "20",
        "currency": "Egyptian Pound",
        "currencyCode": "EGP"
    },
    {
        "code": "EH",
        "label": "Western Sahara",
        "phone": "212",
        "currency": "Dirham",
        "currencyCode": "MAD"
    },
    {
        "code": "ER",
        "label": "Eritrea",
        "phone": "291",
        "currency": "Ethiopian Birr",
        "currencyCode": "ETB"
    },
    {
        "code": "ES",
        "label": "Spain",
        "phone": "34",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "ET",
        "label": "Ethiopia",
        "phone": "251",
        "currency": "Ethiopian Birr",
        "currencyCode": "ETB"
    },
    {
        "code": "FI",
        "label": "Finland",
        "phone": "358",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "FJ",
        "label": "Fiji",
        "phone": "679",
        "currency": "Fijian Dollar",
        "currencyCode": "FJD"
    },
    {
        "code": "FK",
        "label": "Falkland Islands (Malvinas)",
        "phone": "500",
        "currency": "Falkland Pound",
        "currencyCode": "FKP"
    },
    {
        "code": "FM",
        "label": "Micronesia, Federated States of",
        "phone": "691",
        "currency": "USD",
        "currencyCode": "USD"
    },
    {
        "code": "FO",
        "label": "Faroe Islands",
        "phone": "298",
        "currency": "Danish Krone",
        "currencyCode": "DKK"
    },
    {
        "code": "FR",
        "label": "France",
        "phone": "33",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "GA",
        "label": "Gabon",
        "phone": "241",
        "currency": "CFA Franc BEAC",
        "currencyCode": "XAF"
    },
    {
        "code": "GB",
        "label": "United Kingdom",
        "phone": "44",
        "currency": "Sterling",
        "currencyCode": "GBP"
    },
    {
        "code": "GD",
        "label": "Grenada",
        "phone": "1-473",
        "currency": "East Caribbean Dollar",
        "currencyCode": "XCD"
    },
    {
        "code": "GE",
        "label": "Georgia",
        "phone": "995",
        "currency": "Lari",
        "currencyCode": "GEL"
    },
    {
        "code": "GF",
        "label": "French Guiana",
        "phone": "594",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "GG",
        "label": "Guernsey",
        "phone": "44",
        "currency": "Guernsey pound",
        "currencyCode": "GGP"
    },
    {
        "code": "GH",
        "label": "Ghana",
        "phone": "233",
        "currency": "Ghana cedi",
        "currencyCode": "GHS"
    },
    {
        "code": "GI",
        "label": "Gibraltar",
        "phone": "350",
        "currency": "Gibraltar Pound",
        "currencyCode": "GIP"
    },
    {
        "code": "GL",
        "label": "Greenland",
        "phone": "299",
        "currency": "Danish Krone",
        "currencyCode": "DKK"
    },
    {
        "code": "GM",
        "label": "Gambia",
        "phone": "220",
        "currency": "Dalasi",
        "currencyCode": "GMD"
    },
    {
        "code": "GN",
        "label": "Guinea",
        "phone": "224",
        "currency": "Guinean Franc",
        "currencyCode": "GNF"
    },
    {
        "code": "GP",
        "label": "Guadeloupe",
        "phone": "590",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "GQ",
        "label": "Equatorial Guinea",
        "phone": "240",
        "currency": "CFA Franc BEAC",
        "currencyCode": "XAF"
    },
    {
        "code": "GR",
        "label": "Greece",
        "phone": "30",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "GS",
        "label": "South Georgia and the South Sandwich Islands",
        "phone": "500",
        "currency": "Sterling",
        "currencyCode": "GBP"
    },
    {
        "code": "GT",
        "label": "Guatemala",
        "phone": "502",
        "currency": "Quetzal",
        "currencyCode": "GTQ"
    },
    {
        "code": "GU",
        "label": "Guam",
        "phone": "1-671",
        "currency": "USD",
        "currencyCode": "USD"
    },
    {
        "code": "GW",
        "label": "Guinea-Bissau",
        "phone": "245",
        "currency": "CFA Franc BCEAO",
        "currencyCode": "XOF"
    },
    {
        "code": "GY",
        "label": "Guyana",
        "phone": "592",
        "currency": "Guyanaese Dollar",
        "currencyCode": "GYD"
    },
    {
        "code": "HK",
        "label": "Hong Kong",
        "phone": "852",
        "currency": "HKD",
        "currencyCode": "HKD"
    },
    {
        "code": "HM",
        "label": "Heard Island and McDonald Islands",
        "phone": "672",
        "currency": "Australian Dollars",
        "currencyCode": "AUD"
    },
    {
        "code": "HN",
        "label": "Honduras",
        "phone": "504",
        "currency": "Lempira",
        "currencyCode": "HNL"
    },
    {
        "code": "HR",
        "label": "Croatia",
        "phone": "385",
        "currency": "Croatian Dinar",
        "currencyCode": "HRK"
    },
    {
        "code": "HT",
        "label": "Haiti",
        "phone": "509",
        "currency": "Gourde",
        "currencyCode": "HTG"
    },
    {
        "code": "HU",
        "label": "Hungary",
        "phone": "36",
        "currency": "Forint",
        "currencyCode": "HUF"
    },
    {
        "code": "ID",
        "label": "Indonesia",
        "phone": "62",
        "currency": "Indonesian Rupiah",
        "currencyCode": "IDR"
    },
    {
        "code": "IE",
        "label": "Ireland",
        "phone": "353",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "IL",
        "label": "Israel",
        "phone": "972",
        "currency": "Shekel",
        "currencyCode": "ILS"
    },
    {
        "code": "IM",
        "label": "Isle of Man",
        "phone": "44",
        "currency": "Manx pound",
        "currencyCode": "GBP"
    },
    {
        "code": "IN",
        "label": "India",
        "phone": "91",
        "currency": "Indian Rupee",
        "currencyCode": "INR"
    },
    {
        "code": "IO",
        "label": "British Indian Ocean Territory",
        "phone": "246",
        "currency": "USD",
        "currencyCode": "USD"
    },
    {
        "code": "IQ",
        "label": "Iraq",
        "phone": "964",
        "currency": "Iraqi Dinar",
        "currencyCode": "IQD"
    },
    {
        "code": "IR",
        "label": "Iran, Islamic Republic of",
        "phone": "98",
        "currency": "Iranian Rial",
        "currencyCode": "IRR"
    },
    {
        "code": "IS",
        "label": "Iceland",
        "phone": "354",
        "currency": "Icelandic Krona",
        "currencyCode": "ISK"
    },
    {
        "code": "IT",
        "label": "Italy",
        "phone": "39",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "JE",
        "label": "Jersey",
        "phone": "44",
        "currency": "Sterling",
        "currencyCode": "GBP"
    },
    {
        "code": "JM",
        "label": "Jamaica",
        "phone": "1-876",
        "currency": "Jamaican Dollar",
        "currencyCode": "JMD"
    },
    {
        "code": "JO",
        "label": "Jordan",
        "phone": "962",
        "currency": "Jordanian Dinar",
        "currencyCode": "JOD"
    },
    {
        "code": "JP",
        "label": "Japan",
        "phone": "81",
        "currency": "Japanese Yen",
        "currencyCode": "JPY"
    },
    {
        "code": "KE",
        "label": "Kenya",
        "phone": "254",
        "currency": "Kenyan Shilling",
        "currencyCode": "KES"
    },
    {
        "code": "KG",
        "label": "Kyrgyzstan",
        "phone": "996",
        "currency": "Som",
        "currencyCode": "KGS"
    },
    {
        "code": "KH",
        "label": "Cambodia",
        "phone": "855",
        "currency": "Riel",
        "currencyCode": "KHR"
    },
    {
        "code": "KI",
        "label": "Kiribati",
        "phone": "686",
        "currency": "Australian Dollars",
        "currencyCode": "AUD"
    },
    {
        "code": "KM",
        "label": "Comoros",
        "phone": "269",
        "currency": "Comoran Franc",
        "currencyCode": "KMF"
    },
    {
        "code": "KN",
        "label": "Saint Kitts and Nevis",
        "phone": "1-869",
        "currency": "East Caribbean Dollar",
        "currencyCode": "XCD"
    },
    {
        "code": "KP",
        "label": "Korea, Democratic People's Republic of",
        "phone": "850",
        "currency": "Won",
        "currencyCode": "KPW"
    },
    {
        "code": "KR",
        "label": "Korea, Republic of",
        "phone": "82",
        "currency": "Won",
        "currencyCode": "KRW"
    },
    {
        "code": "KW",
        "label": "Kuwait",
        "phone": "965",
        "currency": "Kuwaiti Dinar",
        "currencyCode": "KWD"
    },
    {
        "code": "KY",
        "label": "Cayman Islands",
        "phone": "1-345",
        "currency": "Caymanian Dollar",
        "currencyCode": "KYD"
    },
    {
        "code": "KZ",
        "label": "Kazakhstan",
        "phone": "7",
        "currency": "Tenge",
        "currencyCode": "KZT"
    },
    {
        "code": "LA",
        "label": "Lao People's Democratic Republic",
        "phone": "856",
        "currency": "Kip",
        "currencyCode": "LAK"
    },
    {
        "code": "LB",
        "label": "Lebanon",
        "phone": "961",
        "currency": "Lebanese Pound",
        "currencyCode": "LBP"
    },
    {
        "code": "LC",
        "label": "Saint Lucia",
        "phone": "1-758",
        "currency": "East Caribbean Dollar",
        "currencyCode": "XCD"
    },
    {
        "code": "LI",
        "label": "Liechtenstein",
        "phone": "423",
        "currency": "Swiss Franc",
        "currencyCode": "CHF"
    },
    {
        "code": "LK",
        "label": "Sri Lanka",
        "phone": "94",
        "currency": "Rupee",
        "currencyCode": "LKR"
    },
    {
        "code": "LR",
        "label": "Liberia",
        "phone": "231",
        "currency": "Liberian Dollar",
        "currencyCode": "LRD"
    },
    {
        "code": "LS",
        "label": "Lesotho",
        "phone": "266",
        "currency": "Loti",
        "currencyCode": "LSL"
    },
    {
        "code": "LT",
        "label": "Lithuania",
        "phone": "370",
        "currency": "Lita",
        "currencyCode": "LTL"
    },
    {
        "code": "LU",
        "label": "Luxembourg",
        "phone": "352",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "LV",
        "label": "Latvia",
        "phone": "371",
        "currency": "Lat",
        "currencyCode": "LVL"
    },
    {
        "code": "LY",
        "label": "Libya",
        "phone": "218",
        "currency": "Libyan Dinar",
        "currencyCode": "LYD"
    },
    {
        "code": "MA",
        "label": "Morocco",
        "phone": "212",
        "currency": "Dirham",
        "currencyCode": "MAD"
    },
    {
        "code": "MC",
        "label": "Monaco",
        "phone": "377",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "MD",
        "label": "Moldova, Republic of",
        "phone": "373",
        "currency": "Leu",
        "currencyCode": "MDL"
    },
    {
        "code": "ME",
        "label": "Montenegro",
        "phone": "382",
        "currency": "Euro",
        "currencyCode": "EUR"
    },
    {
        "code": "MF",
        "label": "Saint Martin (French part)",
        "phone": "590",
        "currency": "Netherlands Antillean guilder",
        "currencyCode": "ANG"
    },
    {
        "code": "MG",
        "label": "Madagascar",
        "phone": "261",
        "currency": "Malagasy Franc",
        "currencyCode": "MGA"
    },
    {
        "code": "MH",
        "label": "Marshall Islands",
        "phone": "692",
        "currency": "USD",
        "currencyCode": "USD"
    },
    {
        "code": "MK",
        "label": "Macedonia, the Former Yugoslav Republic of",
        "phone": "389",
        "currency": "Denar",
        "currencyCode": "MKD"
    },
    {
        "code": "ML",
        "label": "Mali",
        "phone": "223",
        "currency": "CFA Franc BCEAO",
        "currencyCode": "XOF"
    },
    {
        "code": "MM",
        "label": "Myanmar",
        "phone": "95",
        "currency": "Kyat",
        "currencyCode": "MMK"
    },
    {
        "code": "MN",
        "label": "Mongolia",
        "phone": "976",
        "currency": "Tugrik",
        "currencyCode": "MNT"
    },
    {
        "code": "MO",
        "label": "Macao",
        "phone": "853",
        "currency": "Pataca",
        "currencyCode": "MOP"
    },
    {
        "code": "MP",
        "label": "Northern Mariana Islands",
        "phone": "1-670",
        "currency": "USD",
        "currencyCode": "USD"
    },
    {
        "code": "MQ",
        "label": "Martinique",
        "phone": "596",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "MR",
        "label": "Mauritania",
        "phone": "222",
        "currency": "Ouguiya",
        "currencyCode": "MRO"
    },
    {
        "code": "MS",
        "label": "Montserrat",
        "phone": "1-664",
        "currency": "East Caribbean Dollar",
        "currencyCode": "XCD"
    },
    {
        "code": "MT",
        "label": "Malta",
        "phone": "356",
        "currency": "Maltese Lira",
        "currencyCode": "MTL"
    },
    {
        "code": "MU",
        "label": "Mauritius",
        "phone": "230",
        "currency": "Mauritian Rupee",
        "currencyCode": "MUR"
    },
    {
        "code": "MV",
        "label": "Maldives",
        "phone": "960",
        "currency": "Rufiyaa",
        "currencyCode": "MVR"
    },
    {
        "code": "MW",
        "label": "Malawi",
        "phone": "265",
        "currency": "Malawian Kwacha",
        "currencyCode": "MWK"
    },
    {
        "code": "MX",
        "label": "Mexico",
        "phone": "52",
        "currency": "Peso",
        "currencyCode": "MXN"
    },
    {
        "code": "MY",
        "label": "Malaysia",
        "phone": "60",
        "currency": "Ringgit",
        "currencyCode": "MYR"
    },
    {
        "code": "MZ",
        "label": "Mozambique",
        "phone": "258",
        "currency": "Metical",
        "currencyCode": "MZN"
    },
    {
        "code": "NA",
        "label": "Namibia",
        "phone": "264",
        "currency": "Dollar",
        "currencyCode": "NAD"
    },
    {
        "code": "NC",
        "label": "New Caledonia",
        "phone": "687",
        "currency": "CFP Franc",
        "currencyCode": "XPF"
    },
    {
        "code": "NE",
        "label": "Niger",
        "phone": "227",
        "currency": "CFA Franc BCEAO",
        "currencyCode": "XOF"
    },
    {
        "code": "NF",
        "label": "Norfolk Island",
        "phone": "672",
        "currency": "Australian Dollars",
        "currencyCode": "AUD"
    },
    {
        "code": "NG",
        "label": "Nigeria",
        "phone": "234",
        "currency": "Naira",
        "currencyCode": "NGN"
    },
    {
        "code": "NI",
        "label": "Nicaragua",
        "phone": "505",
        "currency": "Cordoba Oro",
        "currencyCode": "NIO"
    },
    {
        "code": "NL",
        "label": "Netherlands",
        "phone": "31",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "NO",
        "label": "Norway",
        "phone": "47",
        "currency": "Norwegian Krone",
        "currencyCode": "NOK"
    },
    {
        "code": "NP",
        "label": "Nepal",
        "phone": "977",
        "currency": "Nepalese Rupee",
        "currencyCode": "NPR"
    },
    {
        "code": "NR",
        "label": "Nauru",
        "phone": "674",
        "currency": "Australian Dollars",
        "currencyCode": "AUD"
    },
    {
        "code": "NU",
        "label": "Niue",
        "phone": "683",
        "currency": "New Zealand Dollars",
        "currencyCode": "NZD"
    },
    {
        "code": "NZ",
        "label": "New Zealand",
        "phone": "64",
        "currency": "New Zealand Dollars",
        "currencyCode": "NZD"
    },
    {
        "code": "OM",
        "label": "Oman",
        "phone": "968",
        "currency": "Sul Rial",
        "currencyCode": "OMR"
    },
    {
        "code": "PA",
        "label": "Panama",
        "phone": "507",
        "currency": "Balboa",
        "currencyCode": "PAB"
    },
    {
        "code": "PE",
        "label": "Peru",
        "phone": "51",
        "currency": "Nuevo Sol",
        "currencyCode": "PEN"
    },
    {
        "code": "PF",
        "label": "French Polynesia",
        "phone": "689",
        "currency": "CFP Franc",
        "currencyCode": "XPF"
    },
    {
        "code": "PG",
        "label": "Papua New Guinea",
        "phone": "675",
        "currency": "Kina",
        "currencyCode": "PGK"
    },
    {
        "code": "PH",
        "label": "Philippines",
        "phone": "63",
        "currency": "Peso",
        "currencyCode": "PHP"
    },
    {
        "code": "PK",
        "label": "Pakistan",
        "phone": "92",
        "currency": "Rupee",
        "currencyCode": "PKR"
    },
    {
        "code": "PL",
        "label": "Poland",
        "phone": "48",
        "currency": "Zloty",
        "currencyCode": "PLN"
    },
    {
        "code": "PM",
        "label": "Saint Pierre and Miquelon",
        "phone": "508",
        "currency": "Euro",
        "currencyCode": "EUR"
    },
    {
        "code": "PN",
        "label": "Pitcairn",
        "phone": "870",
        "currency": "New Zealand Dollars",
        "currencyCode": "NZD"
    },
    {
        "code": "PR",
        "label": "Puerto Rico",
        "phone": "1",
        "currency": "USD",
        "currencyCode": "USD"
    },
    {
        "code": "PS",
        "label": "Palestine, State of",
        "phone": "970",
        "currency": "Jordanian dinar",
        "currencyCode": "JOD"
    },
    {
        "code": "PT",
        "label": "Portugal",
        "phone": "351",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "PW",
        "label": "Palau",
        "phone": "680",
        "currency": "USD",
        "currencyCode": "USD"
    },
    {
        "code": "PY",
        "label": "Paraguay",
        "phone": "595",
        "currency": "Guarani",
        "currencyCode": "PYG"
    },
    {
        "code": "QA",
        "label": "Qatar",
        "phone": "974",
        "currency": "Rial",
        "currencyCode": "QAR"
    },
    {
        "code": "RE",
        "label": "Reunion",
        "phone": "262",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "RO",
        "label": "Romania",
        "phone": "40",
        "currency": "Leu",
        "currencyCode": "RON"
    },
    {
        "code": "RS",
        "label": "Serbia",
        "phone": "381",
        "currency": "Serbian dinar",
        "currencyCode": "RSD"
    },
    {
        "code": "RU",
        "label": "Russian Federation",
        "phone": "7",
        "currency": "Ruble",
        "currencyCode": "RUB"
    },
    {
        "code": "RW",
        "label": "Rwanda",
        "phone": "250",
        "currency": "Rwanda Franc",
        "currencyCode": "RWF"
    },
    {
        "code": "SA",
        "label": "Saudi Arabia",
        "phone": "966",
        "currency": "Riyal",
        "currencyCode": "SAR"
    },
    {
        "code": "SB",
        "label": "Solomon Islands",
        "phone": "677",
        "currency": "Solomon Islands Dollar",
        "currencyCode": "SBD"
    },
    {
        "code": "SC",
        "label": "Seychelles",
        "phone": "248",
        "currency": "Rupee",
        "currencyCode": "SCR"
    },
    {
        "code": "SD",
        "label": "Sudan",
        "phone": "249",
        "currency": "Dinar",
        "currencyCode": "SDG"
    },
    {
        "code": "SE",
        "label": "Sweden",
        "phone": "46",
        "currency": "Krona",
        "currencyCode": "SEK"
    },
    {
        "code": "SG",
        "label": "Singapore",
        "phone": "65",
        "currency": "Dollar",
        "currencyCode": "SGD"
    },
    {
        "code": "SH",
        "label": "Saint Helena",
        "phone": "290",
        "currency": "Saint Helena pound",
        "currencyCode": "GBP"
    },
    {
        "code": "SI",
        "label": "Slovenia",
        "phone": "386",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "SJ",
        "label": "Svalbard and Jan Mayen",
        "phone": "47",
        "currency": "Norwegian Krone",
        "currencyCode": "NOK"
    },
    {
        "code": "SK",
        "label": "Slovakia",
        "phone": "421",
        "currency": "Koruna",
        "currencyCode": "SKK"
    },
    {
        "code": "SL",
        "label": "Sierra Leone",
        "phone": "232",
        "currency": "Leone",
        "currencyCode": "SLL"
    },
    {
        "code": "SM",
        "label": "San Marino",
        "phone": "378",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "SN",
        "label": "Senegal",
        "phone": "221",
        "currency": "CFA Franc BCEAO",
        "currencyCode": "XOF"
    },
    {
        "code": "SO",
        "label": "Somalia",
        "phone": "252",
        "currency": "Shilling",
        "currencyCode": "SOS"
    },
    {
        "code": "SR",
        "label": "Suriname",
        "phone": "597",
        "currency": "Surinamese Guilder",
        "currencyCode": "SRD"
    },
    {
        "code": "ST",
        "label": "Sao Tome and Principe",
        "phone": "239",
        "currency": "Dobra",
        "currencyCode": "STD"
    },
    {
        "code": "SV",
        "label": "El Salvador",
        "phone": "503",
        "currency": "Salvadoran Colon",
        "currencyCode": "SVC"
    },
    {
        "code": "SY",
        "label": "Syrian Arab Republic",
        "phone": "963",
        "currency": "Syrian Pound",
        "currencyCode": "SYP"
    },
    {
        "code": "SZ",
        "label": "Swaziland",
        "phone": "268",
        "currency": "Lilangeni",
        "currencyCode": "SZL"
    },
    {
        "code": "TC",
        "label": "Turks and Caicos Islands",
        "phone": "1-649",
        "currency": "USD",
        "currencyCode": "USD"
    },
    {
        "code": "TD",
        "label": "Chad",
        "phone": "235",
        "currency": "CFA Franc BEAC",
        "currencyCode": "XAF"
    },
    {
        "code": "TF",
        "label": "French Southern Territories",
        "phone": "262",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "TG",
        "label": "Togo",
        "phone": "228",
        "currency": "CFA Franc BCEAO",
        "currencyCode": "XOF"
    },
    {
        "code": "TH",
        "label": "Thailand",
        "phone": "66",
        "currency": "Baht",
        "currencyCode": "THB"
    },
    {
        "code": "TJ",
        "label": "Tajikistan",
        "phone": "992",
        "currency": "Tajikistan Ruble",
        "currencyCode": "TJS"
    },
    {
        "code": "TK",
        "label": "Tokelau",
        "phone": "690",
        "currency": "New Zealand Dollars",
        "currencyCode": "NZD"
    },
    {
        "code": "TM",
        "label": "Turkmenistan",
        "phone": "993",
        "currency": "Manat",
        "currencyCode": "TMT"
    },
    {
        "code": "TN",
        "label": "Tunisia",
        "phone": "216",
        "currency": "Tunisian Dinar",
        "currencyCode": "TND"
    },
    {
        "code": "TO",
        "label": "Tonga",
        "phone": "676",
        "currency": "PaÕanga",
        "currencyCode": "TOP"
    },
    {
        "code": "TR",
        "label": "Turkey",
        "phone": "90",
        "currency": "Lira",
        "currencyCode": "TRY"
    },
    {
        "code": "TT",
        "label": "Trinidad and Tobago",
        "phone": "1-868",
        "currency": "Trinidad and Tobago Dollar",
        "currencyCode": "TTD"
    },
    {
        "code": "TV",
        "label": "Tuvalu",
        "phone": "688",
        "currency": "Australian Dollars",
        "currencyCode": "AUD"
    },
    {
        "code": "TW",
        "label": "Taiwan, Province of China",
        "phone": "886",
        "currency": "Dollar",
        "currencyCode": "TWD"
    },
    {
        "code": "TZ",
        "label": "United Republic of Tanzania",
        "phone": "255",
        "currency": "Shilling",
        "currencyCode": "TZS"
    },
    {
        "code": "UA",
        "label": "Ukraine",
        "phone": "380",
        "currency": "Hryvnia",
        "currencyCode": "UAH"
    },
    {
        "code": "UG",
        "label": "Uganda",
        "phone": "256",
        "currency": "Shilling",
        "currencyCode": "UGX"
    },
    {
        "code": "US",
        "label": "United States",
        "phone": "1",
        "currency": "USD",
        "currencyCode": "USD"
    },
    {
        "code": "UY",
        "label": "Uruguay",
        "phone": "598",
        "currency": "Peso",
        "currencyCode": "UYU"
    },
    {
        "code": "UZ",
        "label": "Uzbekistan",
        "phone": "998",
        "currency": "Som",
        "currencyCode": "UZS"
    },
    {
        "code": "VA",
        "label": "Holy See (Vatican City State)",
        "phone": "379",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "VC",
        "label": "Saint Vincent and the Grenadines",
        "phone": "1-784",
        "currency": "East Caribbean Dollar",
        "currencyCode": "XCD"
    },
    {
        "code": "VE",
        "label": "Venezuela",
        "phone": "58",
        "currency": "Bolivar",
        "currencyCode": "VEF"
    },
    {
        "code": "VG",
        "label": "British Virgin Islands",
        "phone": "1-284",
        "currency": "USD",
        "currencyCode": "USD"
    },
    {
        "code": "VI",
        "label": "US Virgin Islands",
        "phone": "1-340",
        "currency": "USD",
        "currencyCode": "USD"
    },
    {
        "code": "VN",
        "label": "Vietnam",
        "phone": "84",
        "currency": "Dong",
        "currencyCode": "VND"
    },
    {
        "code": "VU",
        "label": "Vanuatu",
        "phone": "678",
        "currency": "Vatu",
        "currencyCode": "VUV"
    },
    {
        "code": "WF",
        "label": "Wallis and Futuna",
        "phone": "681",
        "currency": "CFP Franc",
        "currencyCode": "XPF"
    },
    {
        "code": "WS",
        "label": "Samoa",
        "phone": "685",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "YE",
        "label": "Yemen",
        "phone": "967",
        "currency": "Rial",
        "currencyCode": "YER"
    },
    {
        "code": "YT",
        "label": "Mayotte",
        "phone": "262",
        "currency": "Euros",
        "currencyCode": "EUR"
    },
    {
        "code": "ZA",
        "label": "South Africa",
        "phone": "27",
        "currency": "Rand",
        "currencyCode": "ZAR"
    },
    {
        "code": "ZM",
        "label": "Zambia",
        "phone": "260",
        "currency": "Kwacha",
        "currencyCode": "ZMK"
    },
    {
        "code": "ZW",
        "label": "Zimbabwe",
        "phone": "263",
        "currency": "Zimbabwe Dollar",
        "currencyCode": "ZWD"
    }
];


export const currencies = countries.reduce((list, country) => {
    if (!list.includes(country.currencyCode)) {
        list.push(country.currencyCode);
    }
    return list;
}, [])
